import React from "react";
import { Link } from "react-router-dom";
import { appConfigs, toAbsoluteUrl } from "../../../_helpers";
import { Footer } from "../footer/Footer";
import { AsideMenu } from "./aside-menu/AsideMenu";

export const Aside = () => {

    return (
        <aside id="martin-aside" className="border js-fullheight">

            <div className="text-center">
                <Link to="/"><div className="author-img" style={{ backgroundImage: `url(${toAbsoluteUrl('/_media/images/logo.svg')})` }}></div></Link>
                <h1 id="martin-logo">
                    <Link to="/">{appConfigs.app_name}</Link>
                </h1>
                <span className="position">{appConfigs.job_description}</span>
            </div>

            <AsideMenu />
            <Footer />
        </aside>
    )
}